import { Caract_anteproyecto } from '../../../models/caract_anteproyecto.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

import * as moment from 'moment'
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
    selector: "page-caract_anteproyecto",
    templateUrl: "./caract_anteproyecto.component.html",
    styleUrls: ["./caract_anteproyecto.component.css"],
    providers: [FormService]
})

export class Caract_anteproyectoComponent {
      public rows = [];
      public actualRow;
      public caract_anteproyecto: Caract_anteproyecto;
      public form;
      public matcher = new FormService();
      public formNumber;
      public encontrado;

    public fecha;
    public maxDate;
    constructor() {

        this.encontrado = localStorage.getItem("form")


        if(this.encontrado == 3.3){
            this.encontrado = true;
        }

        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            uso_publico: new FormControl(''),
            anteproy_aprob: new FormControl(''),
            numero: new FormControl(''),
            fecha: new FormControl({ value: '', disabled: true })
        })

        if (!JSON.parse(localStorage.getItem("caract_anteproyecto"))) {
            localStorage.setItem("caract_anteproyecto", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("caract_anteproyecto"));
            this.form.controls['uso_publico'].setValue(this.rows[0] ? this.rows[0].uso_publico : '');
            this.form.controls['anteproy_aprob'].setValue(this.rows[0] ? this.rows[0].anteproy_aprob : '');
            this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '');
            this.form.controls['fecha'].setValue(this.rows[0] ? this.rows[0].fecha : null);
        }
         this.caract_anteproyecto = {uso_publico:'',anteproy_aprob:'', numero:'', fecha:null };

    }

    add_caract_anteproy(event?: MatDatepickerInputEvent<Date>, type?) {
        if (event) {

            this.fecha = moment(event.value).format('DD/MM/YYYY')
        }
        else {
            var temp = JSON.parse(localStorage.getItem("caract_anteproyecto"))
            if (temp > 0) {
                this.fecha = temp[0].fecha;

            }
        }

        localStorage.setItem("caract_anteproyecto", JSON.stringify([]));
        this.actualRow = localStorage.getItem("caract_anteproyecto");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            uso_publico: this.form.value.uso_publico,
            anteproy_aprob: this.form.value.anteproy_aprob,
            numero: this.form.value.numero,
            fecha: this.fecha
        })
        localStorage.setItem("caract_anteproyecto", JSON.stringify(this.rows));

    }

    delete_caract_anteproyecto(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("caract_anteproyecto", JSON.stringify(this.rows));
            }
        }
    }

}